<template>
  <v-row
    v-if="userData && !userData.tesseraAttiva && (ifEnte || asdIsAffiliated)"
  >
    <v-col cols="12" class="text-center">
      <v-btn color="primary" @click="tesseramento" :style="dashboardButtonStyle">
        <v-icon>mdi-credit-card-multiple-outline</v-icon>
        <span style="margin-left: 10px">
          {{ dashboardButtonText }}
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "dashboard-tesseramento",

  props: {},
  computed: {
    dashboardButtonText() {
      const customButton = window.systemData && window.systemData.dashboardTesseramentoButton
        ? window.systemData.dashboardTesseramentoButton
        : null;
      return customButton && customButton.text && customButton.text.toString().trim() !== ""
        ? customButton.text
        : this.$t("affiliation_for_season") + this.userData.esercizio.season;
    },
    dashboardButtonStyle() {
      const customButton = window.systemData && window.systemData.dashboardTesseramentoButton
        ? window.systemData.dashboardTesseramentoButton
        : null;
      if (!customButton || !customButton.style || customButton.style.toString().trim() === "") {
        return null;
      }

      return customButton.style
        .toString()
        .split(";")
        .map((part) => part.trim())
        .filter((part) => part !== "")
        .map((part) => part.includes("!important") ? part : part + " !important")
        .join("; ");
    },
  },
  data() {
    return { userData: null };
  },
  methods: {
    tesseramento() {
      this.$router.push("/portal/tesserati/tesseramento");
    },
    loadData() {
      let _ = this;
      _.ifEnte = false;
      _.asdIsAffiliated = false;
      _.loaded = false;
      let url = "/auth/portal/getUserData/";
      // Eventi aperti
      _.chiamataAxios("GET", url).then((response) => {
        _.userData = response.data;
        _.ifEnte = response.data.ifEnte;
        _.asdIsAffiliated = response.data.asdIsAffiliated;
        _.loaded = true;
      });
    },
  },

  mounted() {
    this.loadData();
  },
  watch: {},
};
</script>